/*
 * Copyright (c) 2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
import { getCookie, setCookie } from 'apmui/common/Cookie';
import LaunchType from 'apmui/resource/LaunchType';
import VdiModel, { REMOTE_DESKTOP_TYPE } from './VdiModel';

enum VDI_CLIENT {
    ACTIVEX = 'activex',
    HTML5 = 'html5',
    JAVA = 'java',
    NATIVE = 'native',
}

type LaunchFunction = (resource: VdiModel, type?: LaunchType) => Promise<any>;

interface IVdiClient {
    name: string;
    downloadUrl?: string;
    launch: LaunchFunction;
}

type VdiClientInfo = { [C in VDI_CLIENT]?: IVdiClient };

/** Set user preferences for Remote Desktop resource(-s) */
const VDI_USER_CLIENT_CHOICE = 'F5_VdiUserClientChoice';

function getUserPreferredClient(rdtype: REMOTE_DESKTOP_TYPE) {
    return getCookie(VDI_USER_CLIENT_CHOICE + rdtype) || undefined;
}

function setUserPreferredClient(rdType: REMOTE_DESKTOP_TYPE, value: string): void {
    setCookie(VDI_USER_CLIENT_CHOICE + rdType, value, '/', 365);
}

export {
    VdiClientInfo as default,
    LaunchFunction,
    IVdiClient,
    VDI_CLIENT,
    getUserPreferredClient,
    setUserPreferredClient,
};
